import styled from 'styled-components';

export default styled.div`
  && {
    .edit {
      height: 66px;
      background-color: #ecffb8;
      display: flex;
      align-items: center;
      .title-edit {
        padding-left: 75px;
      }
    }
    .delete-lease {
      padding: 14px 65px;
      display: flex;
      justify-content: flex-end;
      .btn-delete-lease {
        background-color: black;
        color: white;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        border: none;
      }
    }
    .section {
      padding: 42px 65px;
      .rental-edit {
        background-color: #eeeeee;
        height: 427px;
        .input-rental-edit {
          padding-left: 86px;
          padding-top: 44px;
          .dflex {
            display: flex;
            align-items: center;
          }
          .input-width-date {
            width: 171px;
            height: 40px;
          }
          .input-width-select {
            width: 335px;
            height: 40px;
          }
          .input-width {
            width: 301px;
            height: 40px;
          }
          .baseline {
            align-items: baseline;
          }
          .mg-10 {
            margin-left: 10px;
            margin-right: 10px;
          }
          .mg-29 {
            margin-top: 29px;
            margin-right: 29px;
          }
          .mt-20 {
            margin-top: 20px;
          }
          .ml-10 {
            margin-left: 10px;
          }
          .mt-10 {
            margin-top: 10px;
          }
        }
      }
      .table-edit {
        padding-top: 40px;
      }
      .btn-confirm-edit {
        width: 240px;
        height: 60px;
        background-color: #ff8a00;
        color: white;
        text-align: center;
        box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        border: none;
        margin: 0px auto;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
      }

      .※ {
        color: rgba(255, 0, 0, 1);
        height: 18px;
        width: 12px;
        margin-right: 4px;
      }
      .rental-detail {
        background-color: #eeeeee;
        min-height: 360px;
        .input-rental-detail {
          padding-left: 86px;
          padding-top: 44px;
          padding-bottom: 44px;
          .checked-box {
            margin-bottom: 16px;
          }
          .title-check-box {
            font-weight: 600;
            margin-left: 8px;
          }
          .dflex {
            display: flex;
          }
          .dflex-col {
            display: flex;
            align-items: center;
          }
          .ant-form-item {
            margin-bottom: 0px;
          }
          .input-width-date {
            width: 171px;
            height: 40px;
          }
          .input-width-select {
            width: 335px;
            height: 40px;
          }
          .input-width {
            width: 303px;
            height: 40px;
          }
          .baseline {
            align-items: baseline;
          }
          .mg-10 {
            margin-left: 10px;
            margin-right: 10px;
          }
          .mt-20 {
            margin-top: 20px;
          }
          .ml-10 {
            margin-left: 10px;
          }
          .mt-10 {
            margin-top: 10px;
          }
        }
      }
      .table-add-detail {
        margin-top: 65px;
      }
      .form-footer {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
      }
      .btn-back {
        color: white;
        background: #c4c4c4;
        box-shadow: 0 3px 6px rgb(0 0 0 / 25%);
        border-radius: 5px;
        height: 60px;
        width: 150px;
        margin-right: 10px;
      }
      .btn-back: hover {
        background: white;
        border: 1px solid rgba(235, 164, 80, 1);
        color: rgba(235, 164, 80, 1);
      }
      .btn-confirm-register {
        width: 240px;
        height: 60px;
        background-color: #ff8a00;
        color: white;
        text-align: center;
        box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        border: none;
      }
    }
  }
`;
